/**
 * Secondary Navigation Component
 * 二级导航栏组件
 * 
 * 功能：
 * 1. 从第二屏开始显示
 * 2. 显示时隐藏一级导航
 * 3. 滚动时显示/隐藏动画
 */

(function() {
  'use strict';

  function getDefaultUnitSystem() {
    try {
      if (typeof window.getMarketCode === 'function') {
        const marketCode = String(window.getMarketCode() || '').toLowerCase();
        if (marketCode === 'eu') return 'metric';
      }
    } catch (e) {}

    try {
      const pathname = String((window.location && window.location.pathname) || '').toLowerCase();
      if (/^\/(?:en|nl|de|es|fr|it)-eu(?=\/|$)/.test(pathname)) return 'metric';
    } catch (e) {}

    try {
      const lang = String((document.documentElement && document.documentElement.lang) || '')
        .trim()
        .toLowerCase()
        .replace(/_/g, '-');
      if (/^(de|es|fr|it|nl)(-|$)/.test(lang)) return 'metric';
    } catch (e) {}

    return 'imperial';
  }

  class SecondaryNav {
    constructor() {
      this.nav = document.querySelector('[data-component="secondary-nav"]');
      this.primaryNav = document.querySelector('[data-component="navbar"]');
      this.firstScreenHeight = window.innerHeight;
      this.isVisible = false;
      this.lastScrollY = window.scrollY;

      // 初始化单位转换功能（即使没有导航栏也要初始化）
      this.initUnitConverter();

      // 如果有导航栏，初始化导航栏相关功能
      if (this.nav) {
        this.initNavbar();
      }
    }

    initUnitConverter() {
      // 处理所有 "SWITCH TO IMPERIAL" 点击（可能在页面任何地方）
      document.addEventListener('click', (e) => {
        const switchLink = e.target.closest('[data-action="switch-imperial"]');
        if (switchLink) {
          e.preventDefault();
          this.handleSwitchImperial(e);
        }
      });

      // 页面加载时应用保存的单位系统
      this.applySavedUnitSystem();
    }

    initNavbar() {
      // 监听窗口大小变化
      window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
      
      // 监听 logo 点击事件，滚动到顶部
      this.initLogoClickHandler();
      
      // 默认显示二级导航，不隐藏一级导航
      this.nav.classList.add('is-visible');
    }

    initLogoClickHandler() {
      const logoLink = this.nav?.querySelector('.component-secondary-nav__logo-link');
      if (logoLink) {
        logoLink.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
      }
    }

    handleScroll() {
      // this.checkVisibility();
    }

    handleResize() {
      // this.firstScreenHeight = window.innerHeight;
      // this.checkVisibility();
      // 移除高度检查逻辑
    }

    checkVisibility() {
      // 移除可见性检查逻辑
      //const scrollY = window.scrollY || window.pageYOffset;
      //const shouldShow = scrollY > this.firstScreenHeight;
      //if (shouldShow !== this.isVisible) {
      //  this.isVisible = shouldShow;
      //  this.toggleVisibility();
      //}
      //this.lastScrollY = scrollY;
    }

    toggleVisibility() {
      // if (this.isVisible) {
      //   this.nav.classList.add('is-visible');
      //   // 隐藏一级导航
      //   if (this.primaryNav) {
      //     this.primaryNav.style.display = 'none';
      //   }
      // } else {
      //   this.nav.classList.remove('is-visible');
      //   // 显示一级导航
      //   if (this.primaryNav) {
      //     this.primaryNav.style.display = '';
      //   }
      // }
      // 移除切换逻辑，保持始终可见
      this.nav.classList.add('is-visible');
    }

    handleSwitchImperial(e) {
      e.preventDefault();
      // 使用内置的单位转换逻辑
      this.toggleUnitSystem();
    }

    applySavedUnitSystem() {
      // 获取保存的单位系统
      let savedUnit = getDefaultUnitSystem();
      try {
        savedUnit = localStorage.getItem('unitSystem') || getDefaultUnitSystem();
      } catch (e) {
        // 忽略错误
      }

      // 如果保存的是公制，需要转换为公制显示
      if (savedUnit === 'metric') {
        this.applyUnitConversion('metric');
      }

      // 更新按钮文本
      this.updateSwitchButtonText(savedUnit);
    }

    toggleUnitSystem() {
      // 获取当前单位系统（从 localStorage 或默认英制）
      let currentUnit = getDefaultUnitSystem();
      try {
        currentUnit = localStorage.getItem('unitSystem') || getDefaultUnitSystem();
      } catch (e) {
        // 忽略错误
      }

      // 切换单位系统
      const newUnit = currentUnit === 'imperial' ? 'metric' : 'imperial';
      
      // 保存到 localStorage
      try {
        localStorage.setItem('unitSystem', newUnit);
      } catch (e) {
        // 忽略错误
      }

      // 应用单位转换
      this.applyUnitConversion(newUnit);
      
      // 更新按钮文本
      this.updateSwitchButtonText(newUnit);
    }

    applyUnitConversion(targetUnit) {
      // 单位转换映射表（英制 -> 公制）
      // 注意：只转换数值部分，不转换标签（如 "Seat Height" 等标签在两边一致时保持不变）
      const imperialToMetric = {
        // 重量
        '350 LBS': '160 KG',
        '350 lbs': '160 kg',
        '40 lbs': '18 kg',
        '40 lbs (18 kg)': '18 kg (40 lbs)',
        '160 KG': '350 LBS',
        '160 kg': '350 lbs',
        
        // 座椅高度（根据图片：15"-19" -> 150MM-160MM）
        '15" - 19"': '150MM - 160MM',
        '15"-19"': '150MM-160MM',
        '150MM - 160MM': '15" - 19"',
        '150MM-160MM': '15"-19"',

        '15.7" - 19.7"': '400MM - 500MM',
        '15.7"-19.7"': '400MM-500MM',
        '400MM - 500MM': '15.7" - 19.7"',
        '400MM-500MM': '15.7"-19.7"',
        
        // 扶手高度（根据图片：3 LEVELS -> 200MM-260MM）
        '3 LEVELS': '200MM - 260MM',
        '3 LEVELS': '200MM-260MM',
        '200MM - 260MM': '3 LEVELS',
        '200MM-260MM': '3 LEVELS',
        
        // 座椅宽度
        '3 LEVELS': '442MM - 518MM',
        '3 LEVELS': '442MM-518MM',
        '442MM - 518MM': '3 LEVELS',
        '442MM-518MM': '3 LEVELS',
        
        // 速度
        'UP TO 8 MPH': 'UP TO 12.9 KM/H',
        'UP TO 8 MPH': 'UP TO 12.9 KM/H',
        '7 MPH TOP SPEED': '11 KM/H TOP SPEED',
        'UP TO 12.9 KM/H': 'UP TO 8 MPH',
        '11 KM/H TOP SPEED': '7 MPH TOP SPEED',
        
        // 路缘和间隙
        '2" CURBS + 4.7" GAPS': '5CM CURBS + 12CM GAPS',
        '2″ CURBS + 4.7″ GAPS': '5CM CURBS + 12CM GAPS', // 使用英寸符号 ″ (U+2033) 作为备用
        '5CM CURBS + 12CM GAPS': '2" CURBS + 4.7" GAPS', // 反向映射：公制 -> 英制（使用普通引号）
        
        // 续航里程
        'Up to 20 miles of all-day power.': 'Up to 32 km of all-day power.',
        'UP TO 20 MI': 'UP TO 32 KM',
        'UP TO 20 miles': 'UP TO 32 KM',
        'LONG RANGE UP TO 20 MI': 'LONG RANGE UP TO 32 KM',
        'LONG RANGE UP TO 20 miles': 'LONG RANGE UP TO 32 KM',
        'LONG RANGE<br>UP TO 20 MI': 'LONG RANGE<br>UP TO 32 KM',
        'LONG RANGE<br>UP TO 20 miles': 'LONG RANGE<br>UP TO 32 KM',
        '20 MI': '32 KM',
        '20 miles': '32 km',
        'UP TO 32 KM': 'UP TO 20 MI',
        'UP TO 32 km': 'UP TO 20 miles',
        'LONG RANGE UP TO 32 KM': 'LONG RANGE UP TO 20 MI',
        'LONG RANGE UP TO 32 km': 'LONG RANGE UP TO 20 miles',
        'LONG RANGE<br>UP TO 32 KM': 'LONG RANGE<br>UP TO 20 MI',
        'LONG RANGE<br>UP TO 32 km': 'LONG RANGE<br>UP TO 20 miles',
        '32 KM': '20 MI',
        '32 km': '20 miles',
        
        // 飞机友好
        'UP TO 9 MI': 'UP TO 14.5 KM',
        'UP TO 9 miles': 'UP TO 14.5 KM',
        'FLIGHT SAFE UP TO 9 MI': 'FLIGHT SAFE UP TO 14.5 KM',
        'FLIGHT SAFE UP TO 9 miles': 'FLIGHT SAFE UP TO 14.5 KM',
        'FLIGHT SAFE<br>UP TO 9 MI': 'FLIGHT SAFE<br>UP TO 14.5 KM',
        'FLIGHT SAFE<br>UP TO 9 miles': 'FLIGHT SAFE<br>UP TO 14.5 KM',
        '9 MI': '14.5 KM',
        '9 miles': '14.5 km',
        'UP TO 14.5 KM': 'UP TO 9 MI',
        'UP TO 14.5 km': 'UP TO 9 miles',
        'FLIGHT SAFE UP TO 14.5 KM': 'FLIGHT SAFE UP TO 9 MI',
        'FLIGHT SAFE UP TO 14.5 km': 'FLIGHT SAFE UP TO 9 miles',
        'FLIGHT SAFE<br>UP TO 14.5 KM': 'FLIGHT SAFE<br>UP TO 9 MI',
        'FLIGHT SAFE<br>UP TO 14.5 km': 'FLIGHT SAFE<br>UP TO 9 miles',
        '14.5 KM': '9 MI',
        '14.5 km': '9 miles',
        
        // 长文本描述
        'When faced with a step or curb, the ev¹ delivers smooth climbing power to lift the front wheels over edges up to 2 inches and across gaps up to 4.7 inches. Turn challenging thresholds and entrances from obstacles into everyday transitions.': 
        'When faced with a step or curb, the ev¹ delivers smooth climbing power to lift the front wheels over edges up to 5cm and across gaps up to 12cm. Turn challenging thresholds and entrances from obstacles into everyday transitions.',
        'Feel the wind in your hair as you explore at speeds up to 8 mph. The 4-wheel independent suspension cushions bumps and vibrations, keeping the ev¹ comfortable on irregular surfaces, ensuring you experience every ride to the fullest.':
        'Feel the wind in your hair as you explore at speeds up to 12.9 km/h. The 4-wheel independent suspension cushions bumps and vibrations, keeping the ev¹ comfortable on irregular surfaces, ensuring you experience every ride to the fullest.',
        'The ev¹ is designed to be easier to transport and store. It can be separated into up to five compact modules including the battery, with the heaviest piece weighing 42 lbs.':
        'The ev¹ is designed to be easier to transport and store. It can be separated into up to five compact modules including the battery, with the heaviest piece weighing 18.8 kg.',
        'The ev¹ is designed to be easier to transport and store. It can be separated into up to five compact modules including the battery, with the heaviest piece weighing 18.8 kg.':
        'The ev¹ is designed to be easier to transport and store. It can be separated into up to five compact modules including the battery, with the heaviest piece weighing 42 lbs.'
      };

      // 创建反向映射（公制 -> 英制）
      // 由于 imperialToMetric 中已经包含了双向映射，这里只需要为那些值在 imperialToMetric 中不存在作为键的项创建反向映射
      const metricToImperial = {};
      for (const key in imperialToMetric) {
        const value = imperialToMetric[key];
        // 如果该值在 imperialToMetric 中不存在作为键，则创建反向映射
        // 如果该值已经存在作为键，说明已经有双向映射，跳过
        if (!(value in imperialToMetric)) {
          // 如果该值还没有映射，或者当前键更短（更精确），则使用当前键
          if (!metricToImperial[value] || key.length < metricToImperial[value].length) {
            metricToImperial[value] = key;
          }
        }
      }
      
      // 特殊处理：确保 'UP TO 12.9 KM/H' 映射回 'UP TO 8MPH'（不带空格，与页面实际使用一致）
      if (metricToImperial['UP TO 12.9 KM/H']) {
        metricToImperial['UP TO 12.9 KM/H'] = 'UP TO 8MPH';
      }
      
      // 特殊处理：确保 '5CM CURBS + 12CM GAPS' 优先映射回带普通引号的版本
      if (metricToImperial['5CM CURBS + 12CM GAPS']) {
        metricToImperial['5CM CURBS + 12CM GAPS'] = '2" CURBS + 4.7" GAPS';
      }

      // 根据目标单位选择映射表
      const mappings = targetUnit === 'imperial' ? metricToImperial : imperialToMetric;
      const normalizedMappings = this.normalizeMappings(mappings);

      // 查找所有标记了 data-unit-convert 的元素
      const elements = document.querySelectorAll('[data-unit-convert]');
      
      elements.forEach(element => {
        // 检查是否允许 HTML 内容
        const allowHtml = element.hasAttribute('data-allow-html') && element.getAttribute('data-allow-html') === 'true';
        const imperialLabel = element.getAttribute('data-unit-imperial-label');
        const metricLabel = element.getAttribute('data-unit-metric-label');
        
        // 获取原始文本（支持 HTML）
        let originalText;
        if (allowHtml) {
          originalText = element.getAttribute('data-original-text') || element.innerHTML.trim();
        } else {
          originalText = element.getAttribute('data-original-text') || element.textContent.trim();
        }
        const normalizedOriginal = this.normalizeConvertibleText(originalText, allowHtml);
        
        // 保存原始文本（如果是第一次）
        if (!element.hasAttribute('data-original-text')) {
          element.setAttribute('data-original-text', normalizedOriginal);
        }
        
        // 获取保存的原始文本
        const savedOriginal = this.normalizeConvertibleText(
          element.getAttribute('data-original-text'),
          allowHtml
        );
        
        // 转换文本
        let convertedText = targetUnit === 'imperial' ? imperialLabel : metricLabel;
        
        if (!convertedText) {
          convertedText = savedOriginal;

          // 尝试精确匹配
          if (normalizedMappings[savedOriginal]) {
            convertedText = normalizedMappings[savedOriginal];
          } else {
            // 尝试部分匹配和替换
            let text = savedOriginal;
            const sortedKeys = Object.keys(normalizedMappings).sort((a, b) => b.length - a.length);
            
            for (const key of sortedKeys) {
              const regex = new RegExp(this.escapeRegex(key), 'gi');
              if (regex.test(text)) {
                text = text.replace(regex, normalizedMappings[key]);
              }
            }
            convertedText = text;
          }
        }
        
        // 更新元素内容
        if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
          element.value = convertedText;
        } else if (allowHtml) {
          element.innerHTML = convertedText;
        } else {
          element.textContent = convertedText;
        }
      });
    }

    normalizeMappings(mappings) {
      const normalized = {};
      for (const key in mappings) {
        const normalizedKey = this.normalizeConvertibleText(key, key.indexOf('<br') !== -1);
        const normalizedValue = this.normalizeConvertibleText(
          mappings[key],
          mappings[key].indexOf('<br') !== -1
        );
        normalized[normalizedKey] = normalizedValue;
      }
      return normalized;
    }

    normalizeConvertibleText(text, allowHtml) {
      let normalized = String(text || '')
        .replace(/\r\n?/g, '\n')
        .replace(/&nbsp;|\u00a0/gi, ' ');

      if (allowHtml) {
        normalized = normalized
          .replace(/<br\s*\/?>/gi, '<br>')
          .replace(/\s*<br>\s*/gi, '<br>');
      }

      normalized = normalized
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n[ \t]+/g, '\n')
        .replace(/[ \t]{2,}/g, ' ')
        .trim();

      if (!allowHtml) {
        normalized = normalized.replace(/\s+/g, ' ');
      }

      return normalized;
    }

    updateSwitchButtonText(currentUnit) {
      const switchLinks = document.querySelectorAll('[data-action="switch-imperial"]');
      switchLinks.forEach(link => {
        const metricLabel = link.dataset.switchToMetricLabel || 'SWITCH TO METRIC';
        const imperialLabel = link.dataset.switchToImperialLabel || 'SWITCH TO IMPERIAL';
        if (currentUnit === 'imperial') {
          link.textContent = metricLabel;
        } else {
          link.textContent = imperialLabel;
        }
      });
    }

    escapeRegex(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  }

  // 创建全局实例
  let secondaryNavInstance = null;
  
  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      secondaryNavInstance = new SecondaryNav();
      window.SecondaryNavInstance = secondaryNavInstance;
    });
  } else {
    secondaryNavInstance = new SecondaryNav();
    window.SecondaryNavInstance = secondaryNavInstance;
  }
})();

